import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { useMe } from "../App";
import { ApiError, api, post } from "../api";

export function AcceptInvite() {
  const { token } = useParams();
  const me = useMe();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [info, setInfo] = useState<{ brand: string; email: string; role: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api<{ brand: string; email: string; role: string }>(`/v1/public/invites/${token}`)
      .then(setInfo)
      .catch((e) => setError(e instanceof ApiError ? e.message : "This invite isn't valid."));
  }, [token]);
  const accept = async () => {
    try {
      const r = await post<{ workspaceId: string }>(`/v1/invites/${token}/accept`, {});
      await qc.invalidateQueries({ queryKey: ["me"] });
      navigate(`/w/${r.workspaceId}`);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Something went wrong.");
    }
  };
  const loggedIn = Boolean(me.data);
  return (
    <div className="public">
      <main className="sheet">
        <img src="/logo.svg" alt="Brandwall" style={{ height: 26 }} />
        {error && <div className="error">{error}</div>}
        {info && (
          <>
            <h1 style={{ fontSize: 22 }}>Join {info.brand} on Brandwall</h1>
            <p className="muted">
              You're invited as {info.role === "viewer" ? "a viewer" : `an ${info.role}`}. Use{" "}
              {info.email} to log in or sign up.
            </p>
            {loggedIn ? (
              <button type="button" className="btn block" onClick={accept}>
                Accept the invite
              </button>
            ) : (
              <Link
                className="btn block"
                to={`/login?returnTo=${encodeURIComponent(`/invite/${token}`)}`}
              >
                Log in or create an account
              </Link>
            )}
          </>
        )}
      </main>
    </div>
  );
}
